import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import Apply from "App/Apply/Apply";
import { useLead } from "_contexts/useLead";
import { useSettings } from "_contexts/useSettings";
import { useStats } from "_contexts/useStats";
import { Loading } from "_styleguide";

function App() {
  const { lead, reload } = useLead();
  const { settings, isPreview } = useSettings();
  const { initializeVisitorTracking } = useStats();

  useEffect(() => {
    const adjustForKeyboard = () => {
      const viewportHeight = window.innerHeight;
      document.documentElement.style.setProperty(
        "--vh",
        `${viewportHeight * 0.01}px`
      );

      if (window.innerHeight < window.outerHeight * 0.7) {
        // Keyboard is open
        document.body.classList.add("keyboard-open");
      } else {
        // Keyboard is closed
        document.body.classList.remove("keyboard-open");
      }
    };

    window.addEventListener("resize", adjustForKeyboard);
    adjustForKeyboard(); // Run on mount

    return () => {
      window.removeEventListener("resize", adjustForKeyboard);
    };
  }, []);

  // Initialize visitor tracking when settings are available
  useEffect(() => {
    if (settings?.id && initializeVisitorTracking) {
      // Use the self enrollment ID from settings
      const selfEnrollmentId = settings.id;
      if (selfEnrollmentId) {
        initializeVisitorTracking(selfEnrollmentId);
      }
    }
    if ((!lead && settings) || isPreview) {
      reload();
    }
  }, [settings?.id, initializeVisitorTracking, isPreview]);

  const globalProps = {};
  const applyRoutes = <Apply {...globalProps} />;

  let routes = applyRoutes;
  if (process.env.REACT_APP_ROLE_TYPE === "construction") {
    document.title = "PayPath | Under Construction";
    routes = null;
  }


  if (!settings || lead === undefined) {
    return <Loading />;
  }

  return routes ? (
    <BrowserRouter>{routes}</BrowserRouter>
  ) : (
    <div>Under construction</div>
  );
}

export default App;
